import { Badge, HStack, Icon, Text, Tooltip } from "@chakra-ui/react"
import type { FC } from "react"

import { BadgeDollar } from "@/ui/components/icons/font-awesome/BadgeDollar"
import { BadgeDollarCross } from "@/ui/components/icons/font-awesome/BadgeDollarCross"

type EligibleBadgeProps = {
  isEligible: boolean
  notEligibleLabel?: string
  useV2IneligibleBadge?: boolean
}
const EligibleBadge: FC<EligibleBadgeProps> = ({
  isEligible,
  notEligibleLabel = "Not eligible to earn rewards for their delegators",
  useV2IneligibleBadge = false,
}) => {
  if (isEligible) {
    return (
      <Badge
        borderRadius="md"
        colorScheme="green"
        fontSize="sm"
        fontWeight="medium"
        my="9px"
        px={2}
        py={1}
        textTransform="none"
      >
        <HStack>
          <Icon as={BadgeDollar} h={4} w={4} />
          <Text>Eligible</Text>
        </HStack>
      </Badge>
    )
  }

  if (useV2IneligibleBadge) {
    return (
      <Badge
        borderRadius="md"
        color="warning.700"
        colorScheme="warning"
        fontSize="sm"
        fontWeight="medium"
        my="9px"
        px={2}
        py={1}
        textTransform="none"
      >
        <Text>Ineligible</Text>
      </Badge>
    )
  }

  return (
    <Tooltip label={notEligibleLabel}>
      <Icon
        as={BadgeDollarCross}
        color="gray.400"
        fontWeight="bold"
        h={5}
        w={5}
      />
    </Tooltip>
  )
}

export default EligibleBadge
